import ContactView from './ContactView.html';
import { ContactController } from './ContactController';
const ContactComponent = {
    template: ContactView,
    controllerAs: '$ctrl',
    controller: ContactController,
    bindings: {
        contact: '<',
        checkable: '<?',
        blocked: '=?',
        onToogle: '<?',
        onDelete: '<?',
        size: '@?',
        disposable: '=?',
        onDispose: '<?',
        blockedWarning: '@?',
        isMoving: '<?',
    },
};
export default ContactComponent;
